import React, { useEffect, useRef, useState } from 'react';
import Toggle from '../../../components/Toggle';
import { RuleSentence } from './RuleSentence';

const RuleCardMenu = ({ onEdit, onDelete }) => {
    const [open, setOpen] = useState(false);
    const ref = useRef(null);

    useEffect(() => {
        if (!open) return;
        const handler = (e) => {
            if (ref.current && !ref.current.contains(e.target)) setOpen(false);
        };
        document.addEventListener('mousedown', handler);
        return () => document.removeEventListener('mousedown', handler);
    }, [open]);

    return (
        <div className="rule-card__menu" ref={ref} onClick={(e) => e.stopPropagation()}>
            <button
                type="button"
                className="rule-card__menu-btn"
                onClick={() => setOpen((o) => !o)}
                aria-label="Mais opções"
            >
                ⋮
            </button>
            {open && (
                <div className="rule-card__menu-dropdown">
                    <button
                        type="button"
                        onClick={() => { onEdit(); setOpen(false); }}
                    >
                        Editar
                    </button>
                    <button
                        type="button"
                        className="danger"
                        onClick={() => { onDelete(); setOpen(false); }}
                    >
                        Excluir
                    </button>
                </div>
            )}
        </div>
    );
};

export const RuleCard = ({ rule, index, onEdit, onToggle, onDelete, dragHandle }) => (
    <div className={`rule-card ${rule.is_active ? '' : 'rule-card--paused'}`}>
        {dragHandle}
        {typeof index === 'number' && <span className="rule-card__index">{index + 1}</span>}

        <button
            type="button"
            className="rule-card__sentence"
            onClick={onEdit}
            aria-label="Editar automação"
            title="Clique para editar"
        >
            <RuleSentence rule={rule} />
            {!rule.is_active && <span className="rule-card__paused">Pausada</span>}
        </button>

        <div className="rule-card__actions" onClick={(e) => e.stopPropagation()}>
            <Toggle
                checked={rule.is_active}
                onChange={() => onToggle(rule)}
                label={rule.is_active ? 'Pausar automação' : 'Ativar automação'}
            />
            <RuleCardMenu onEdit={onEdit} onDelete={() => onDelete(rule)} />
        </div>
    </div>
);

export default RuleCard;
